import { createPinia } from 'pinia';
import Button from 'primevue/button';
import Column from 'primevue/column';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import Skeleton from 'primevue/skeleton';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import { createApp } from 'vue';

import App from './App.vue';
import 'primevue/resources/themes/md-light-indigo/theme.css';
import './style.css';

import 'primeicons/primeicons.css';

import { button as buttonStyles } from './presets/button/Button';
import { datatableStyles } from './presets/dataTable/DataTable';
import { dialog as dialogStyles } from './presets/dialog/Dialog';
import { dropdownStyles } from './presets/dropdown/dropdown';
import { fileUploadStyles } from './presets/fileUpload/fileUpload';
import { inputtextStyle } from './presets/input/Input';
import { menuBarStyles } from './presets/menubar/menubar';
import { multiselectStyles } from './presets/multiselect/multiselect';
import { paginatorStyles } from './presets/paginator/Paginator';
import { passwordStyles } from './presets/password/Password';
import { tieredMenuStyles } from './presets/tieredMenu/tieredMenu';
import { toast as toastStyles } from './presets/toast/Toast';
import { router } from './Router';

const CURRENT_VERSION = __APP_VERSION__;
const SAVED_VERSION = localStorage.getItem('app_version');

if (SAVED_VERSION !== CURRENT_VERSION) {
  console.log(`[App] New version detected: ${CURRENT_VERSION}`);

  localStorage.clear();
  localStorage.setItem('app_version', CURRENT_VERSION);

  window.location.reload();
}

const pinia = createPinia();

const app = createApp(App);

app.use(pinia);

app.use(PrimeVue, {
  ripple: true,
  pt: {
    multiselect: multiselectStyles,
    toast: toastStyles,
    dialog: dialogStyles,
    datatable: datatableStyles,
    password: passwordStyles,
    inputtext: inputtextStyle,
    checkbox: inputtextStyle,
    paginator: paginatorStyles,
    menubar: menuBarStyles,
    button: buttonStyles,
    tieredmenu: tieredMenuStyles,
    fileupload: fileUploadStyles,
    dropdown: dropdownStyles,
  },
});

app.use(ConfirmationService);

app.use(router);

app.use(ToastService);

app.component('DataTable', DataTable);

app.component('Toast', Toast);

app.component('InputText', InputText);

app.component('Checkbox', Checkbox);

app.component('Dialog', Dialog);

app.component('Button', Button);

app.component('Skeleton', Skeleton);

app.component('Column', Column);

app.component('ProgressSpinner', ProgressSpinner);

app.component('Dropdown', Dropdown);

app.mount('#app');
